// `new Date('2025-06-01')` parses ISO date-only strings as UTC midnight, so `formatDate`
// (local time) can shift back one day for users west of UTC. Build the Date from its
// components so it lands on local midnight of the intended day.
export const parseReceiptDate = (value: string | undefined): Date | undefined => {
  if (!value) {
    return undefined
  }

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch

    return new Date(Number(year), Number(month) - 1, Number(day))
  }

  const parsed = new Date(value)

  return Number.isNaN(parsed.getTime()) ? undefined : parsed
}
